document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelector(".js-select")
    ?.addEventListener("change", function handleSelectChange() {
      const selectedValue = this.value;
      if (selectedValue) {
        window.location.href = selectedValue;
      }
    });
});
